import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.services';
import { ToastMessageService } from 'src/app/toastr.service';

@Component({
  selector: 'app-error-list',
  templateUrl: './error-list.component.html',
  styleUrls: ['./error-list.component.scss']
})
export class ErrorListComponent implements OnInit {
  allData = [];
  cases = ["costing"]
  month_year;
  caseValue = "";
  monthValue = "";
  yearValue = "";
  case = "";

  constructor(private toastService: ToastMessageService, private homeservice: HomeService) { 

  }

  ngOnInit(): void {}

  searchData() {    
    if(!this.month_year || !this.caseValue) {
      this.toastService.error('Missing required field !');
      return;
    }

    let temp = this.month_year.split("-");

    this.monthValue = temp[1];
    this.yearValue = temp[0];

    let data = { 
      month : parseInt(this.monthValue),
      year: parseInt(this.yearValue),
      case: this.caseValue
    }
    // console.log(data);
    
    this.homeservice.checkCaseOfAPI(data).subscribe((response) => {
      // console.log(response);
      
      this.allData = response

      if(response){
        this.toastService.success('Data Fetched Successfully');
        return; 
      }
      else {
        this.toastService.error('Data Not Found !');
        return; 
      }
    })
  }

  onSelected(event): void {
    console.log(event.target.value);
  }

  clearFilter() {
    this.month_year = "";
    this.caseValue = "false";
    this.allData = [];
  }

}
